var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9648 8.7147C11.3065 8.37299 11.8605 8.37299 12.2022 8.7147L16.8689 13.3814C17.2106 13.7231 17.2106 14.2771 16.8689 14.6188L12.2022 19.2855C11.8605 19.6272 11.3065 19.6272 10.9648 19.2855C10.6231 18.9438 10.6231 18.3897 10.9648 18.048L15.0127 14.0001L10.9648 9.95213C10.6231 9.61042 10.6231 9.05641 10.9648 8.7147Z",
    fill: "#071E0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretRight);
export default __webpack_public_path__ + "static/media/caret-right.2399e6ee47d08cdded5e1662f16e4fcf.svg";
export { ForwardRef as ReactComponent };